import React from 'react';
import RevenueListItem from './RevenueListItem';
import MiniSparkline from './MiniSparkline';
import { formatSwissAmount } from './formatSwiss';
import { totalAnnualHt, lineTotal } from './computeBillingKpis';
import { rotateValuesForDisplay } from './monthRotation';
import { useP } from '../../../i18n/useP';

// Ligne de synthèse « Total » en tête de liste : agrégat de toutes les lignes,
// lecture seule, sélectionnable (son graphique s'affiche dans le panneau détail).
function TotalListItem({ revenue, selected, startMonth, onSelect }) {
  const p = useP();
  const total = lineTotal(revenue);
  const displayValues = rotateValuesForDisplay(revenue.monthly_values, startMonth);
  return (
    <div
      className={`billing-list__item billing-list__item--total ${selected ? 'billing-list__item--selected' : ''}`}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(); } }}
    >
      <div className="billing-list__item-text">
        <span className="billing-list__item-label">{p('Total')}</span>
        <div className="billing-list__item-meta">
          <span className="billing-list__item-total-static">{formatSwissAmount(total)}</span>
        </div>
      </div>
      <MiniSparkline values={displayValues} color="#2B203E" width={120} height={36} />
    </div>
  );
}

// Compact left rail listing every revenue line. Header shows count and
// grand total HT. Children = RevenueListItem (one button each, focuses
// the detail panel on click). When `totalRevenue` is provided, a read-only
// "Total" row sits at the top (its detail chart shows on selection).
export default function RevenueList({ revenues, totalRevenue = null, selectedId, locked = false, startMonth = 0, onSelect, onPatch, onMove }) {
  const p = useP();
  const count = revenues.length;
  const grandTotal = totalAnnualHt(revenues);
  return (
    <aside className="billing-list">
      <div className="billing-list__header">
        <span className="billing-list__count">
          {count} {count > 1 ? p('lignes') : p('ligne')}
        </span>
        <span className="billing-list__divider">·</span>
        <span className="billing-list__grand-total">
          {formatSwissAmount(grandTotal)}
        </span>
      </div>
      <div className="billing-list__items">
        {totalRevenue && count > 0 && (
          <TotalListItem
            revenue={totalRevenue}
            selected={selectedId === totalRevenue.id}
            startMonth={startMonth}
            onSelect={() => onSelect(totalRevenue.id)}
          />
        )}
        {revenues.map((rev, idx) => (
          <RevenueListItem
            key={rev.id}
            revenue={rev}
            colorIndex={idx}
            startMonth={startMonth}
            selected={rev.id === selectedId}
            locked={locked}
            canMoveUp={idx > 0}
            canMoveDown={idx < revenues.length - 1}
            onMoveUp={() => onMove && onMove(idx, -1)}
            onMoveDown={() => onMove && onMove(idx, +1)}
            onSelect={() => onSelect(rev.id)}
            onPatch={(payload) => onPatch(rev.id, payload)}
          />
        ))}
        {count === 0 && (
          <div className="billing-list__empty">
            {p('Aucune ligne. Utilisez le menu « + Ajouter une ligne » ci-dessus.')}
          </div>
        )}
      </div>
    </aside>
  );
}
